import * as Yup from "yup";

export const itemEventoFiscalValidator = Yup.object().shape({
  ordem: Yup.number()
    .typeError("Ordem")
    .required("Ordem"),
  unidade: Yup.string().required("Unidade"),
  quantidade: Yup.number()
    .typeError("Quantidade")
    .positive("Quantidade")
    .required("Quantidade"),
  valorIbs: Yup.number("Valor IBS").required(),
  valorCbs: Yup.number("Valor CBS").required(),
});
